import React from "react";

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
    >
      <path
        fill="#DA3A34"
        d="M20.902.167C9.469.167.167 9.513.167 21 .167 32.487 9.512 41.833 21 41.833c11.487 0 20.833-9.346 20.833-20.833 0-11.487-9.39-20.833-20.931-20.833zm2.181 31.25h-4.166V27.25h4.166v4.167zm0-8.334h-4.166v-12.5h4.166v12.5z"
      ></path>
    </svg>
  );
}

export default InfoIcon;
